import React from 'react';
import SectionHeading from '../../../Components/Shared/SectionHeading';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


import Review from './Review';

const CustomersSays = () => {
    return (
        <div className='hidden md:block'>
            <SectionHeading text={"Our Happy Customers Says"} />

            <Swiper
                loop={true}
                spaceBetween={30}
                pagination={{
                    clickable: true
                }}
                autoplay={{
                    delay: 2500
                }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
            >

                {
                    Array.from({ length: 10 }).map((_, id) =>
                        <SwiperSlide key={id}>
                            <Review />
                        </SwiperSlide>
                    )
                }



            </Swiper>
        </div>
    );
};

export default CustomersSays;